import { useState, useEffect, useCallback } from "react";
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { Box, Flex, Tag, TagLabel, TagLeftIcon, Collapse, useDisclosure, Text } from "@chakra-ui/react";
import { getFullName, getUserDetailsUsingDsrMembersArray } from '../../../profile/helpers/user-helper';
import DsrFaqTextAreaInput from "../../../forms/TextareaField/components/DsrFaqTextAreaInput";
import { getThisUserIdToken } from "../../../global/helpers/global-helpers";
import { TiMessage } from "react-icons/ti";
import { displayReactIcon } from "../../helpers/dsr-display-helpers";
import { TbSquareChevronUpFilled, TbSquareChevronDownFilled } from "react-icons/tb";
import { displayElapsedDurationSinceTimestamp } from "../../../global/helpers/time-format-helpers";

function PendingFaqDisplay({ 
  dsrId, 
  dsrTeamMembers, 
  isDsrAdmin, 
  showPendingQuestions, 
  pendingQuestions, 
  dsrUserTeam,
  userAccountProfile, 
  isRoomTemplate, 
  isLockedRoom, 
  showButtonsSpacer, 
  isArchivedDsr 
}) {

  const { isOpen, onClose, onToggle } = useDisclosure()
  const [editQuestionMode, setEditQuestionMode] = useState(false)
  const [actOnQuestionId, setActOnQuestionId] = useState("")
  const [unfocusBackground, setUnfocusBackground] = useState(false)

  const [templateOwnerProfile, setTemplateOwnerProfile] = useState("")

  // Checks if current session user is a seller member. If yes, then render this. If not, don't return anything
  const isSellerTeam = (dsrUserTeam === "host") ? true : false;

  useEffect(() => {
    if (!!isRoomTemplate) {
      if (userAccountProfile) {
        const templateOwnerName = getFullName(userAccountProfile)
        setTemplateOwnerProfile({
          memberName: templateOwnerName
        })
      }
    }
  }, [isRoomTemplate, userAccountProfile])

  function handleClickCreateFaqAnswer(questionId) {
    onToggle()
    setActOnQuestionId(questionId)
    setUnfocusBackground(false)
  }

  const handleCloseInputArea = useCallback(() => {
    setActOnQuestionId("")
    setEditQuestionMode(false)
    setUnfocusBackground(false)
    onClose()
  }, [onClose]); // Add dependencies here if required

  function handleClickEditQuestion(questionId) {
    setEditQuestionMode(true)
    setActOnQuestionId(questionId)
    setUnfocusBackground(true)
    onClose()
  }

  function renderPendingQuestions() {
    const thisUserId = getThisUserIdToken();
    const faqSet = (pendingQuestions?.length > 0) && pendingQuestions.map((question, questionIndex) => {
      const {
        questionId, questionTextContent,
        questionCreatedAt, questionAuthorUserId } = question || {};

      const questionAuthorProfile = getUserDetailsUsingDsrMembersArray(dsrTeamMembers, questionAuthorUserId);
      const { memberName } = questionAuthorProfile || {};
      const isAuthor = (questionAuthorUserId === thisUserId) ? true : false;
      const isThisQuestion = (questionId === actOnQuestionId) ? true : false
      const unfocusThisQuestion = (editQuestionMode === true && !isThisQuestion) ? true : false;
      const displayedMemberName = isRoomTemplate ? templateOwnerProfile.memberName : memberName ? memberName : "";


      if (editQuestionMode === true && isThisQuestion) {
        return (
          <Flex key={`qn_` + questionIndex + questionId} w='100%' justify='space-between'>
            <Box
              w='100%'
              bg={(unfocusBackground && isThisQuestion) ? 'gray.200' : 'gray.50'} transition="background-color 0.8s ease"
              mb='2.6em' border='1px solid rgba(203, 213, 224, 0.5)' rounded='0.25em'>
              <DsrFaqTextAreaInput
                userActionRequired='edit-faq-question'
                name="editFaqQuestion"
                label="Edit"
                sublabel=""
                placeholder=""
                fontSize='1em'
                htmlFor="editFaqQuestion"
                handleCloseInputArea={handleCloseInputArea}
                dsrId={dsrId}
                questionId={actOnQuestionId}
                currentValue={questionTextContent}
                setActOnQuestionId={setActOnQuestionId}
                bg={(unfocusBackground && isThisQuestion) && 'white'}
              />
            </Box>
            {isDsrAdmin && !isLockedRoom && !!showButtonsSpacer && <Box flex='1em'>
              {renderDummyChangePositionButtons()}
            </Box>
            }
          </Flex>
        )
      }

      if (isSellerTeam === false && !isRoomTemplate) {
        return (
          <Flex key={`qn_` + questionIndex + questionId} w='100%' justify='space-between'>
            <Box w='100%' mb='2.6em' bg='gray.50' p='1.2em 1.5em' opacity={unfocusThisQuestion ? "0.5" : "1.0"} border='1px solid rgba(203, 213, 224, 0.5)' rounded='0.25em'>
              <Box textAlign="left">
                <Box fontWeight='500' fontSize='1em' lineHeight='1.5em' color='brandDark.500'>{questionTextContent}</Box>
              </Box>
              <Box fontStyle='italic' fontSize='0.8em' fontWeight='400'>
                <Flex align='center' justify='flex-start' mt='0.2em'>
                  <Text inline fontWeight='semibold'> {displayedMemberName}</Text>
                  {questionCreatedAt && <Box fontWeight='500' ml='0.5em'> - {displayElapsedDurationSinceTimestamp(questionCreatedAt)}</Box>}
                </Flex>
                {(isAuthor || isDsrAdmin) && !isArchivedDsr && 
                  <Flex justify='flex-start' align='center' color='gray.500' mt='1em' cursor='pointer' onClick={() => handleClickEditQuestion(questionId)}>
                    <Box>{displayReactIcon("edit", '1em')}</Box>
                    <Text inline fontSize='0.875em' > Edit Question</Text>
                  </Flex>
                }
              </Box>
            </Box>
            {isDsrAdmin && <Box flex='1em'>
              {renderDummyChangePositionButtons()}
            </Box>
            }
          </Flex>
        )
      }

      if ((((isSellerTeam === true) || !!isRoomTemplate))) {
        return (
          <Flex key={`qn_` + questionIndex + questionId} w='100%' justify='space-between'>
            <Box
              w='100%'
              mb='2.6em'
              bg='gray.50'
              p='1.2em 1.5em'
              border='1px solid rgba(203, 213, 224, 0.5)' rounded='0.25em'>
              <Box textAlign="left">
                <Box fontWeight='500' fontSize='1em' lineHeight='1.5em' color='brandDark.500'>{questionTextContent}</Box>
              </Box>

              <Box fontStyle='italic' fontSize='0.8em' fontWeight='400'>
                <Flex align='flex-end' justify='flex-start' mt='0.2em'>
                  <Text inline fontWeight='semibold'> {displayedMemberName}</Text>
                  {questionCreatedAt && <Box fontWeight='500' fontSize='0.8em' ml='0.5em'> {displayElapsedDurationSinceTimestamp(questionCreatedAt)}</Box>}
                </Flex>

{!isArchivedDsr && 
                <Flex justify='flex-start' align='center'
                  display={(actOnQuestionId) ? 'none' : "flex"}
                  gap={12}
                  mt='2em'>
                  {(isAuthor || isDsrAdmin) && 
                    <Flex justify='flex-start' align='center' color='gray.500' cursor='pointer' gap='0.5em' onClick={() => handleClickEditQuestion(questionId)}>
                      <Box>{displayReactIcon("edit", '1em')}</Box>
                      <Text inline fontSize='0.875em'>Edit Question</Text>
                    </Flex>
                  }

                  <Flex justify='flex-start' align='center' color='brand.500' cursor='pointer' gap='0.5em' onClick={() => handleClickCreateFaqAnswer(questionId)}>
                    <Box>{displayReactIcon("faq", '1em')}</Box>
                    <Text inline fontSize='0.875em'>Answer Question</Text>
                  </Flex>

                </Flex>
      }
              </Box>

              <Box mt='1em' >
                <Collapse in={(actOnQuestionId === questionId) && isOpen} animateOpacity>
                  <Box
                    p='0.5em 1em'
                    color='white'
                    bg='gray.200'
                    rounded='0.25em'
                  >
                    <DsrFaqTextAreaInput
                      userActionRequired='create-faq-answer'
                      name="createFaqAnswer"
                      label="Answer"
                      sublabel=""
                      placeholder={memberName ? `Provide an answer to ${memberName}` : `Provide an answer here`}
                      fontSize='0.875em'
                      htmlFor="createFaqAnswer"
                      handleCloseInputArea={handleCloseInputArea}
                      dsrId={dsrId}
                      questionId={actOnQuestionId}
                      setActOnQuestionId={setActOnQuestionId}
                      bg={(unfocusBackground && isThisQuestion) && 'white'}
                    />
                  </Box>
                </Collapse>
              </Box>

            </Box>
            {isDsrAdmin && !isLockedRoom && !!showButtonsSpacer && <Box flex='1em'>
              {renderDummyChangePositionButtons()}
            </Box>
            }
          </Flex>
        )
      }

      else return null;
    }



    )
    return faqSet
  }


  function renderDummyChangePositionButtons() {
    return (
      <Flex w='100%' visibility='hidden' direction='column' justify='flex-end' align='center' gap={2} px='0.5em'>
        <Box as={TbSquareChevronUpFilled} boxSize="1.5em" color="gray.300" transition="color 0.3s ease" />
        <Box as={TbSquareChevronDownFilled} boxSize="1.5em" color="gray.300" transition="color 0.3s ease" />
      </Flex>
    )
  }

  if (showPendingQuestions) {
    return (
      <>
        <Flex w='100%' justify='space-between' mt='3em'>
          <Flex w='100%'
            bgGradient="linear(to-r, #141e30, #243b55)"
            rounded='0.25em' border='1px solid' borderColor='gray.200' mb='0.5em' p='1em 1em'>
            <Tag bg='none' fontSize='1.2em' fontWeight='600' lineHeight='2.25em' w='100%' >
              <TagLeftIcon color='brandPink.500' as={TiMessage} bg='white' rounded='50%' boxSize='1.25em' p='0.1em' />
              <TagLabel pl='0.5em' color='white'>Pending answers</TagLabel>
            </Tag>
          </Flex>
          {isDsrAdmin && !isLockedRoom && !!showButtonsSpacer &&
            <Box flex='1em'>
              {renderDummyChangePositionButtons()}
            </Box>
          }
        </Flex>
        <Box>{renderPendingQuestions()}</Box>
      </>
    );
  } else return null;

}




function mapStateToProps(state) {
  return {
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    dsrUserTeam: state.dsrUserTeam.userTeam,
    userAccountProfile: state.userProfile.accountUserProfile,
    isArchivedDsr: state.isArchivedDsr.results,
    isRoomTemplate: state.dsrTemplateId.isRoomTemplate,
    isLockedRoom: state.lockedRoomCheck.isLockedRoom,
  };
}


export default withRouter(connect(mapStateToProps, null)(PendingFaqDisplay));
